/* eslint-disable */
import { Injectable } from '@angular/core';
import { INgCustomStepDefinition } from './customizable-slider.interface';


@Injectable()
export class CustomizableSliderHelper {

	/**------------------------------------------------------
	 * Compatibility Helper
	 */
	isTouchEvent(event: any): boolean {
		if ((window as any).TouchEvent !== undefined) return event instanceof TouchEvent;
		return event.touches !== undefined;
	}

	isResizeObserverAvailable(): boolean {
		return (window as any).ResizeObserver !== undefined;
	}


	/**------------------------------------------------------
	 * Math Helper
	 */
	roundToPrecisionLimit(value: number, precisionLimit: number): number {
		return +(value.toPrecision(precisionLimit));
	}

	isModuloWithinPrecisionLimit(value: number, modulo: number, precisionLimit: number): boolean {
		const limit: number = Math.pow(10, -precisionLimit);
		return Math.abs(value % modulo) <= limit || Math.abs(Math.abs(value % modulo) - modulo) <= limit;
	}

	clampToRange(value: number, floor: number, ceil: number): number {
		return Math.min(Math.max(value, floor), ceil);
	}


	/**------------------------------------------------------
	 * Value Helper
	 */
	linearValueToPosition(val: number, minVal: number, maxVal: number): number {
		const range: number = maxVal - minVal;
		return (val - minVal) / range;
	}

	logValueToPosition(val: number, minVal: number, maxVal: number): number {
		val 	= Math.log(val);
		minVal 	= Math.log(minVal);
		maxVal 	= Math.log(maxVal);
		const range: number = maxVal - minVal;
		return (val - minVal) / range;
	}

	linearPositionToValue(percent: number, minVal: number, maxVal: number): number {
		return percent * (maxVal - minVal) + minVal;
	}

	logPositionToValue(percent: number, minVal: number, maxVal: number): number {
		minVal = Math.log(minVal);
		maxVal = Math.log(maxVal);
		const value: number = percent * (maxVal - minVal) + minVal;
		return Math.exp(value);
	}

	findStepIndex(modelValue: number, stepsArray: INgCustomStepDefinition[]): number {

		//0 - get differences between steps
		const differences: number[] = stepsArray.map((step: INgCustomStepDefinition): number => Math.abs(modelValue - step.value));

		//1 - get min difference Index
		let minDifferenceIndex: number = 0;
		for (let index: number = 0; index < stepsArray.length; index++) {

			// set min difference
			if (differences[index] !== differences[minDifferenceIndex] && differences[index] < differences[minDifferenceIndex]) minDifferenceIndex = index;
		}

		//2 - return min difference index
		return minDifferenceIndex;
	}
}
